module.exports = __webpack_public_path__ + "static/media/golden-hands.9e748c8b.jpg";